import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import TrustBar from "@/components/site/TrustBar";
import About from "@/components/site/About";
import Process from "@/components/site/Process";
import Services from "@/components/site/Services";
import ApplicationForm from "@/components/site/ApplicationForm";
import FacebookFeed from "@/components/site/FacebookFeed";
import ProjectTeaser from "@/components/site/ProjectTeaser";
import BlogTeaser from "@/components/site/BlogTeaser";
import Testimonials from "@/components/site/Testimonials";
import Footer from "@/components/site/Footer";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 200);
    }
  }, [location]);

  return (
    <div data-testid="home-page" className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero />
        <TrustBar />
        <About />
        <Process />
        <Services />
        <ProjectTeaser />
        <ApplicationForm />
        <FacebookFeed />
        <BlogTeaser />
        <Testimonials />
      </main>
      <Footer />
    </div>
  );
}
